import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from './ui/sonner';

export const DashboardLayout = () => {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <Sidebar />
      <main className="lg:ml-72 min-h-screen">
        <div className="p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
      <Toaster position="bottom-right" richColors />
    </div>
  );
};
